module.exports = __webpack_public_path__ + "img/gui_00_landing_1_title.a4a70f38.png";